import { Link } from "wouter";

export default function Hero() {
  return (
    <section id="home" className="pt-28 pb-16 md:pt-32 md:pb-24 bg-elegant-gradient relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[rgba(125,155,118,0.05)] rounded-full -mr-32 -mt-32"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-[rgba(26,54,93,0.05)] rounded-full -ml-24 -mb-24"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <span className="inline-block px-4 py-1 bg-[rgba(125,155,118,0.1)] text-[#7d9b76] rounded-full text-sm font-medium mb-4">Certified Accounting Professional in Salt Lake County</span>
            <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a365d] mb-6 leading-tight">
              Draper, Utah's Premier <span className="text-[#7d9b76]">Accounting Services</span> with Nationwide Reach
            </h1>
            <div className="h-1 w-24 bg-[#7d9b76] mb-6"></div>
            <p className="text-lg mb-6 text-gray-700 leading-relaxed">
              Welcome to SW Accounting, based in the heart of Draper, Utah. I'm Sarah Willardsen, and I've been helping businesses throughout Salt Lake City, Utah County, and across the United States succeed financially for over 20 years with personalized accounting solutions tailored to your industry needs. From our Utah office, we proudly serve clients remotely in all 50 states.
            </p>
            <div className="flex flex-wrap gap-3 mb-8">
              <span className="bg-white px-4 py-2 rounded-full text-[#1a365d] font-medium shadow-elegant flex items-center">
                <i className="fas fa-check-circle text-[#7d9b76] mr-2"></i>
                20+ Years Experience
              </span>
              <span className="bg-white px-4 py-2 rounded-full text-[#1a365d] font-medium shadow-elegant flex items-center">
                <i className="fas fa-certificate text-[#7d9b76] mr-2"></i>
                QuickBooks Certified
              </span>
              <span className="bg-white px-4 py-2 rounded-full text-[#1a365d] font-medium shadow-elegant flex items-center">
                <i className="fas fa-chart-line text-[#7d9b76] mr-2"></i>
                Financial Accuracy
              </span>
            </div>
            <div className="flex flex-wrap gap-4">
              <Link 
                href="/booking"
                className="bg-[#7d9b76] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-md transition-all duration-300 shadow-elegant flex items-center"
              >
                <i className="fas fa-calendar-check mr-2"></i> Book a Consultation
              </Link>
              <Link 
                href="/services"
                className="border-2 border-[#7d9b76] text-[#7d9b76] hover:bg-[#7d9b76] hover:text-white font-bold py-3 px-8 rounded-md transition-all duration-300 flex items-center"
              >
                <i className="fas fa-list-check mr-2"></i> Our Services
              </Link>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center relative">
            {/* Decorative frame */}
            <div className="absolute inset-0 border-8 border-white rounded-lg shadow-elegant transform translate-x-4 translate-y-4 opacity-50"></div>
            
            <picture>
              <source srcSet="/images/staff/webp/sarah-adam-wall.webp" type="image/webp" />
              <source srcSet="/images/staff/sarah-adam-wall.jpg" type="image/jpeg" />
              <img 
                src="/images/staff/sarah-adam-wall.jpg" 
                alt="Sarah & Adam Willardsen, Professional Accountants in Draper, Utah | SW Accounting Salt Lake County" 
                className="rounded-lg shadow-elegant max-w-full h-auto relative z-10" 
                width="500" 
                height="600"
                loading="eager" 
                fetchPriority="high"
                title="Sarah & Adam Willardsen - Utah's Trusted Accountants Serving Draper, Salt Lake City and Nationwide"
              />
            </picture>
            
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#7d9b76] rounded-lg opacity-10 z-0"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
